var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "\n  sw-grid-flex\n  sw-grid-flex--dir-column--tab\n  sw-grid-flex--wrap--tab\n  sw--padding-vert-4"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "sw--height-full sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center"
        },
        [
          _c(
            "div",
            { staticClass: "sw-grid-flex__cell-1-1" },
            _vm._l(_vm.tabs, function(tab, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "left gray-tab",
                  class:
                    _vm.selectedTabIndex === index ? "gray-tab--disabled" : "",
                  on: {
                    click: function($event) {
                      _vm.selectedTabIndex = index
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(tab.title) + "\n      ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sw-grid-flex__cell-1-1 sw--padding-top-3" },
            [
              _c(
                "keep-alive",
                [
                  _c(
                    _vm.selectedTab.component,
                    _vm._b(
                      {
                        tag: "component",
                        attrs: {
                          "material-id": _vm.materialId,
                          "printer-technology-ids": _vm.printerTechnologyIds,
                          "current-material": _vm.currentMaterial
                        },
                        on: {
                          error: _vm.handleError,
                          success: _vm.handleSuccess
                        }
                      },
                      "component",
                      _vm.selectedTab.props,
                      false
                    )
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }